<template>
  <transition name="fade-indicator">
    <div
      v-if="visible"
      class="connection-indicator"
      :class="stateClass"
      :title="title"
    ></div>
  </transition>
</template>

<script>
export default {
  name: "ConnectionIndicator",
  props: {
    state: {
      type: String,
      default: "disconnected",
      validator: (v) =>
        [
          "disconnected",
          "connecting",
          "connected",
          "reconnecting",
          "failed",
        ].includes(v),
    },
  },
  data() {
    return {
      fadeTimer: null,
      visible: false,
    };
  },
  computed: {
    stateClass() {
      if (this.state === "connected") return "green";
      if (this.state === "reconnecting" || this.state === "connecting")
        return "yellow";
      return "red";
    },
    title() {
      if (this.state === "connected") return "Connected";
      if (this.state === "reconnecting" || this.state === "connecting")
        return "Reconnecting...";
      return "Disconnected";
    },
  },
  watch: {
    state: {
      immediate: true,
      handler(newState) {
        clearTimeout(this.fadeTimer);
        if (newState === "connected") {
          this.visible = true;
          this.fadeTimer = setTimeout(() => {
            this.visible = false;
          }, 3000);
        } else if (newState === "disconnected") {
          // Don't show on initial load before first connection
          this.visible = false;
        } else {
          this.visible = true;
        }
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.fadeTimer);
  },
};
</script>

<style lang="scss" scoped>
.connection-indicator {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);

  &.green {
    background-color: #22c55e;
    box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);
  }

  &.yellow {
    background-color: #eab308;
    box-shadow: 0 0 6px rgba(234, 179, 8, 0.5);
    animation: pulse 1.5s ease-in-out infinite;
  }

  &.red {
    background-color: #ef4444;
    box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.fade-indicator-enter-active {
  transition: opacity 0.3s ease;
}
.fade-indicator-leave-active {
  transition: opacity 1.5s ease;
}
.fade-indicator-enter,
.fade-indicator-leave-to {
  opacity: 0;
}
</style>
